<template>
  <div class="guide-select">
    <div class="guide-select-container">
      <div class="guide-title">
        {{ title }}
        <img :src="imageMobile" class="hide-desktop" />
      </div>
      <div class="select">
        <select name="intensidad" id="intensidad" @change="getIntensity($event)">
          <option disabled="disabled" selected="true">IntenSidad nominal</option>
          <option v-for="(item, index) in data" :value="item.value" :key="index">{{ item.value }}</option>
        </select>
        <div class="select_arrow" />
      </div>

      <div class="select" @change="getCode($event)" :class="[activeSelected ? '' : 'disabled']">
        <select v-model="selectedPole" name="intensidad" id="intensidad">
          <option disabled="disabled" selected="true">Número de polos</option>
          <option
            v-for="(polo, index) in selectPole[0].polos"
            :value="polo.code"
            :key="index"
          >{{ polo.polo }}</option>
        </select>
        <div class="select_arrow" />
      </div>

      <div class="product-code">
        {{ result }}
        <span>{{ code || '. . .' }}</span>
      </div>

      <!-- <div class="required-text">{{ required }}</div> -->
    </div>

    <img :src="image" class="hide-mobile" />
  </div>
</template>

<script>
export default {
  props: ["data", "required", "result", "image", "imageMobile", "title"],
  data() {
    return {
      selectedIntensity: null,
      selectedPole: "Número de polos",
      code: false,
      activeSelected: false,
    };
  },
  methods: {
    getCode(event) {
      this.code = event.target.value;
    },
    getIntensity(event) {
      this.selectedIntensity = event.target.value;
      this.selectedPole = "Número de polos";
      this.code = false;
      this.activeSelected = true;
    },
  },
  computed: {
    selectPole() {
      let intensity = this.selectedIntensity;

      if (intensity) {
        return this.data.filter(function (resp) {
          return resp.value === intensity;
        });
      } else {
        return this.data;
      }
    },
  },
};
</script>

<style lang="scss" src="./Select.scss" />